import { ConsignmentStockInListPage } from "@/features/consignment-stockin/pages/ConsignmentStockInListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockin/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["consignment_stock_in.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ConsignmentStockInListPage,
});
